<template>
	<output :class="['eb-banner', {'eb-banner-bg': withBackground}, 'eb-banner-' + type, 'eb-banner-' + position, {'visually-hidden': !isActive} ]" :role="type == 'error' ? 'alert': 'status'">
		<span v-if="isActive" class="eb-banner-content">
			<span class="eb-banner-icon" aria-hidden="true">
				<font-awesome-icon v-if="type === 'error'" :icon="['fas', 'times-circle']" size="lg" />
				<font-awesome-icon v-if="type === 'warning'" :icon="['fas', 'exclamation-triangle']" size="lg" />
				<font-awesome-icon v-if="type === 'success'" :icon="['fas', 'check-circle']" size="lg" />
				<font-awesome-icon v-if="type === 'info'" :icon="['fas', 'info-circle']" size="lg" />
				<font-awesome-icon v-if="type === 'waiting'" :icon="['fas', 'pause-circle']" size="lg" />
			</span>
			<div class="eb-banner-right-content">
				<small v-if="timestamp" v-html="timestamp"></small>
				<div class="eb-banner-text">
					<span v-if="title" class="eb-banner-title">{{ title }}</span>
					<slot />
				</div>
			</div>
		</span>
		<EbButton v-if="displayCloseButton && isActive" hierarchy="text" withIcon="icon-only" class="eb-banner-icon-close" title="Fermer le message" @click="$emit('removeBanner', true)">
			<font-awesome-icon :icon="['fas', 'times']" />
		</EbButton>
	</output>
</template>
<script>
export default {
	name: "EbBanner",
	props: {
		type: {
			type: String,
			default: null,
			validator: value => {
				return value.match(/(error|warning|success|info|waiting)/)
			},
		},
		position: {
			type: String,
			default: null,
			validator: value => {
				return value.match(/(top|bottom|ieDisclaimer)/)
			},
		},
		withBackground: {
			type: Boolean,
			default: true,
		},
		title: {
			type: String,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
		displayCloseButton: {
			type: Boolean,
			default: false,
		},
		timestamp: {
			type: String,
		}
	}
}
</script>
<style lang="scss" scoped>
@mixin banner($disclaimer: false) {
	@include stack-space($eb-space-l);
	display: flex;
	justify-content: space-between;
	align-items: center;
	box-shadow: box-shadow-size(16);
	background: $white;
	color: $black;
	border: $eb-border-default;
	border-radius: $eb-radius-m;
	min-height: $eb-tappable-square;
	text-align: left;
	
	@if $disclaimer {
		border-radius: 0;
		@include stack-space($eb-space-none);
	}
}

.eb-banner {
	@include banner();
	
	&-top,
	&-bottom {
		position: fixed;
		left: 0;
		z-index: $eb-zindex-toast;
	}
	&-top {
		top: 0;
		width: 100%;
	}
	&-bottom {
		bottom: 0;
		left: auto;
		right: 0;
		width: 80%;
	}
	
	&-icon {
		color: $white;
		border-radius: $eb-radius-m 0 0 $eb-radius-m;
		display: flex;
		justify-content: center;
		align-items: center;
		min-width: $eb-tappable-square;
		@include inset-space($eb-space-default);
		
		&-close {
			@include inset-space($eb-space-default);
			min-width: $eb-tappable-square;
			min-height: $eb-tappable-square;
			&:hover,
			&:active,
			&:focus {
				cursor: pointer;
			}
		}
	}
	
	&-content {
		font-size: $eb-font-size-default;
		display: flex;
	}
	
	&-title {
		text-transform: uppercase;
		font-size: $eb-font-size-xl;
		font-weight: $eb-font-weight-medium;
		display: block;
	}
	
	&-right-content {
		display: flex;
		flex-direction: column;
		@include inset-squish-space($eb-space-l);
	}
	
	&-error {
		.eb-banner-icon {
			background-color: $eb-color-error;
		}
	}
	&-warning {
		.eb-banner-icon {
			background-color: $eb-color-warning;
		}
	}
	&-success {
		.eb-banner-icon {
			background-color: $eb-color-success;
		}
	}
	&-info {
		.eb-banner-icon {
			background-color: $eb-color-info;
		}
	}
	&-waiting {
		.eb-banner-icon {
			background-color: $eb-color-waiting;
		}
	}
	
	&-bg {
		.eb-banner-icon {
			color: $white;
		}
		&.eb-banner-error {
			background-color: $eb-color-error-light;
			border-color: $eb-color-error-dark;
			color: $eb-color-error-dark;
		}
		&.eb-banner-warning {
			background-color: $eb-color-warning-light;
			border-color: $eb-color-warning-dark;
			color: $eb-color-warning-dark;
		}
		&.eb-banner-success {
			background-color: $eb-color-success-light;
			border-color: $eb-color-success-dark;
			color: $eb-color-success-dark;
		}
		&.eb-banner-info {
			background-color: $eb-color-info-light;
			border-color: $eb-color-info-dark;
			color: $eb-color-info-dark;
		}
		&.eb-banner-waiting {
			background-color: $eb-color-waiting-light;
			border-color: $eb-color-waiting-dark;
			color: $eb-color-waiting-dark;
		}
	}
	
	&-ieDisclaimer {
		@include banner($disclaimer: true);
		.eb-banner-icon {
			border-radius: 0;
			min-width: calc(#{$eb-tappable-square} + 4px);
			@include respond-to("large-up") {
				min-width: 64px;
			}
		}
	}
}
</style>
